import { Job } from "@models/job.model";
import { httpRequest } from "../../http";
import { JobSerializer } from "@models/serializers/jobSerializer";

export class CommandGetJobStatus {
  async run(jobId: number) {
    try {
      const request = await httpRequest<any>(
        `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/jobs/${jobId}/status/`,
        {
          method: "GET",
        }
      );
      return this.deserialize(request);
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }

  deserialize(data: any): Job {
    const serializer = new JobSerializer();
    return serializer.deserialize(data);
  }
}
